import Vue from 'vue';
import Overlay from './Overlay.vue';
import router from './router/overlay';
import store from './store';

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(Overlay),
});
